const contentful = require("contentful")

const contentfulClient = contentful.createClient({
    space: "mbxbn7xgp06t",
    accessToken: "9nODS_Rs2WqSXpS7gYSfrz8g3brdNUKgwWx_MEGXFhQ",
})

export default contentfulClient
